import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import ProgressBar from "../components/progress-bar"
import { Link } from "react-router-dom"
import { AiOutlineInfo } from "react-icons/ai"
import { DatePicker, Drawer, Switch, Select, Space } from "antd"
import Footer from "../components/footer"

const WorkHistoryPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [open, setOpen] = useState(false);
    const [currentlyWorking, setCurrentlyWorking] = useState(true)
    const [reasonsForLeaving, setReasonsForLeaving] = useState(["Assignment completed", "To pursue new opportunity", "Took time of for personal reasons", "Took time of for career advancement", "Assignment canceled - low census", "Assignment canceled - facility closure", "Assignment cancelled - other", "Other"])
    const [reasonsForLeavingSearch, setReasonsForLeavingSearch] = useState()
    const [specialityOptions, setSpecialityOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [specialitySearch, setSpecialitySearch] = useState()
    const [facilityTypeOptions, setFacilityTypeOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [facilityTypeSearch, setFacilityTypeSearch] = useState()
    const [chartingSystemOptions, setChartingSystemOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [chartingSystemSearch, setChartingSystemSearch] = useState()
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [isTraumaFacility, setIsTraumaFacility] = useState(false)
    const [teachingFacility, setTeachingFacility] = useState(false)
    const [magnetFacility, setMagnetFacility] = useState(false)
    const [traumaLvl, setTraumaLvl] = useState(isTraumaFacility ? 1 : null)
    const [chargeExperience, setChargeExperience] = useState(false)


    const { Option } = Select

    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    const onDateChangeStart = (date, dateString) => {
        console.log(date, dateString, "start");
        setStartDate(date)
    };

    const onDateChangeEnd = (date, dateString) => {
        console.log(date, dateString);
        setEndDate(date)
    };

    const onClose = () => {
        setOpen(false);
    };

    const DrawerFooter = () => {
        return (
            <div className="flex justify-center items-center">
                <div className="flex flex-col gap-y-1 w-fit">
                    <button className="bg-cyan-400 py-2 rounded-full px-20" onClick={() => setOpen(false)}>DONE</button>
                    <button className="underline text-cyan-600" onClick={() => setOpen(false)}>CANCEL</button>
                </div>
            </div>
        )
    }

    return (
        <Navbar active={"My jobs"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full font-semibold">Work History</h1>
            </div>
            <div className="relative top-14">
                <div className="px-3 mt-3">
                    <div>
                        <h1 className="font-semibold mb-2">Application progress</h1>
                        <ProgressBar active={"work history"} />
                    </div>
                    <p className="text-sm mt-2">
                        Your work history is a crucial piece of securing your next and future positions. Please provide your work history for the last 7 years (if you haven't been working that long, that's ok) and list as much information as possible for each position held (patient ratios, # of beds in unit, etc.).
                    </p>
                    <div className="mt-6">
                        <button onClick={() => setOpen(true)} className="uppercase border-2 font-semibold rounded-full px-2 py-2 text-sm border-cyan-500">
                            Add Work History
                        </button>
                    </div>
                </div>
            </div>
            <div className="fixed bottom-0 w-full">
                <div className="bg-white p-3 border-t-2">
                    <div className="flex items-center gap-x-1">
                        <span className="h-5 w-5 rounded-full border border-blue-500 flex justify-center items-center">
                            <AiOutlineInfo className="text-blue-500" />
                        </span>
                        <span className="text-blue-500">Add atleast 1 Work history to continue</span>
                    </div>
                    <div className="flex gap-x-4 mt-2">
                        <button disabled={true} className="uppercase border border-cyan-400 py-1 px-6 rounded-full disabled:cursor-not-allowed disabled:bg-gray-400 disabled:border-0 disabled:text-gray-200 text-sm text-center">
                            save & continue
                        </button>
                        <Link to={"/education"} className="uppercase border border-cyan-400 py-1 px-6 rounded-full text-sm text-center">
                            skip to next section
                        </Link>
                    </div>
                </div>
                <Footer></Footer>
            </div>
            <Drawer title="Work History" placement="right" onClose={onClose} open={open} footer={<DrawerFooter />}>
                <div className="px-1">
                    <div className="border-b pb-4">
                        <h1 className="uppercase text-sm font-semibold text-gray-500">Dates</h1>
                        <div className="flex justify-between">
                            <span>Currently working on this role</span>
                            <Switch className="bg-gray-200" onChange={(e) => setCurrentlyWorking(e)} checked={currentlyWorking}></Switch>
                        </div>
                        <div className="mt-4">
                            <span className="text-[12px]">
                                Start date
                                <span className="text-red-500">
                                    *
                                </span>
                            </span>
                            <DatePicker disabledDate={current => current && current > Date.now()} onChange={onDateChangeStart} className="w-full p-1 py-2" />
                        </div>
                        {
                            !currentlyWorking &&
                            <div className="mt-2">
                                <span className="text-[12px]">
                                    End date
                                    <span className="text-red-500">
                                        *
                                    </span>
                                </span>
                                <DatePicker onChange={onDateChangeEnd} className="w-full p-1 py-2" />
                            </div>
                        }
                        {
                            !currentlyWorking &&
                            <div className="mt-2">
                                <span className="text-[12px]">
                                    Reason of leaving
                                    <span className="text-red-500">
                                        *
                                    </span>
                                </span>
                                <Select
                                    mode="multiple"
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Reason for leaving"
                                    optionLabelProp="label"
                                    value={reasonsForLeavingSearch}
                                    onChange={(e) => setReasonsForLeavingSearch(e[e.length - 1])}
                                >

                                    {
                                        reasonsForLeaving?.map((val, i) => {
                                            return (
                                                <Option key={i} value={val} label={val}>
                                                    <Space>
                                                        {val}
                                                    </Space>
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </div>
                        }
                    </div>

                    <div className="border-b pb-4 mt-6">
                        <div>
                            <h1 className="uppercase text-sm font-semibold text-gray-500">Facility</h1>
                            <div class="relative mt-2">
                                <input type="text" id="location" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                <label for="location" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Location</label>
                            </div>
                            <div class="relative mt-3">
                                <input type="text" id="facility" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                <label for="facility" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Facility</label>
                            </div>
                            <div class="relative mt-3">
                                <input type="text" id="profession" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                <label for="profession" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Profession</label>
                            </div>
                            <div className="mt-3">
                                <Select
                                    mode="multiple"
                                    className="w-full"
                                    placeholder="Speciality"
                                    optionLabelProp="label"
                                    value={specialitySearch}
                                    onChange={(e) => setSpecialitySearch(e)}
                                >

                                    {
                                        specialityOptions?.map((val, i) => {
                                            return (
                                                <Option key={i} value={val} label={val}>
                                                    <Space>
                                                        {val}
                                                    </Space>
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </div>
                        </div>
                        <div className="mt-6 flex flex-col gap-y-3">
                            <label className="flex items-center gap-x-1 w-fit">
                                <input checked={teachingFacility === true} onChange={() => setTeachingFacility(!teachingFacility)} type="checkbox" name="" id="" className="checked:ring-0" />
                                This is a teaching facility
                            </label>
                            <label className="flex items-center gap-x-1 w-fit">
                                <input checked={isTraumaFacility === true} onChange={() => setIsTraumaFacility(!isTraumaFacility)} type="checkbox" name="" id="" className="checked:ring-0" />
                                This is a trauma facility
                            </label>
                            {
                                isTraumaFacility &&
                                <div className="flex items-center">
                                    <div>
                                        Trauma Level
                                    </div>
                                    <div>
                                        <select onChange={(e) => console.log(e.target.value)} className="border-0 border-b focus:ring-0 active:ring-0 ">
                                            <option selected value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </select>
                                    </div>
                                </div>
                            }
                            <label className="flex items-center gap-x-1">
                                <input checked={magnetFacility === true} onChange={() => setMagnetFacility(!magnetFacility)} type="checkbox" name="" id="" className="checked:ring-0" />
                                This is a magnet facility
                            </label>
                        </div>
                        <div className="flex items-center gap-x-2 mt-6">
                            <div class="relative">
                                <input type="text" id="facility_beds" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                <label for="facility_beds" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"># of facility beds</label>
                            </div>
                            <div class="relative">
                                <input type="text" id="beds_unit" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                <label for="beds_unit" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"># of beds in unit</label>
                            </div>
                        </div>
                        <div className="mt-4">
                            {/* <h1 className="text-sm text-gray-700">Type</h1> */}
                            <Select
                                mode="multiple"
                                className="w-full"
                                placeholder="Select Type"
                                optionLabelProp="label"
                                value={facilityTypeSearch}
                                onChange={(e) => setFacilityTypeSearch(e[e.length - 1])}
                            >

                                {
                                    facilityTypeOptions?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>

                        <div className="relative mt-4">
                            <input type="text" id="nurse_to_patient" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                            <label for="nurse_to_patient" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Nurse to patient ratio*</label>
                        </div>

                        <div className="mt-4">
                            <h1>Charting system</h1>
                            <Select
                                mode="multiple"
                                className="w-full"
                                placeholder="Charting system"
                                optionLabelProp="label"
                                value={chartingSystemSearch}
                                onChange={(e) => setChartingSystemSearch(e[e.length - 1])}
                            >

                                {
                                    chartingSystemOptions?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>

                        <div className="relative mt-4">
                            <input type="text" id="shift" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                            <label for="shift" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Shift* Eg. 3 x 12 days</label>
                        </div>

                        <div className="mt-4">
                            <h1 className="font-semibold">Any charge experience</h1>
                            <div className="flex flex-col  gap-y-2">
                                <label className="flex items-center gap-x-2">
                                    <input type="radio" name="charge_exp" id="" checked={chargeExperience === true} onChange={() => setChargeExperience(!chargeExperience)} />
                                    No
                                </label>
                                <label className="flex items-center gap-x-2">
                                    <input type="radio" name="charge_exp" checked={chargeExperience === false} onChange={() => setChargeExperience(!chargeExperience)} />
                                    Yes
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="border-b pb-4 mt-6">
                        <div>
                            <h1 className="uppercase text-sm font-semibold text-gray-500">References</h1>

                            <div className="flex flex-col w-full gap-y-4 mt-2">
                                <div class="relative">
                                    <input type="text" id="ref_name" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                    <label for="ref_name" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Reference name</label>
                                </div>
                                <div class="relative">
                                    <input type="text" id="title" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                    <label for="title" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Title</label>
                                </div>
                                <div class="relative">
                                    <input type="text" id="ref_email" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                    <label for="ref_email" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Email</label>
                                </div>
                                <div class="relative">
                                    <input type="text" id="ref_phone" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                    <label for="ref_phone" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Reference Phone</label>
                                </div>
                            </div>

                            <div className="mt-4">
                                <label className="flex w-fit gap-x-2 items-center">
                                    <input type="checkbox" name="" id="" className="checked:bg-gray-600 focus:ring-0 checked:ring-0" />
                                    Ok to contact reference
                                </label>
                            </div>

                        </div>
                    </div>


                </div>
            </Drawer>
        </Navbar>
    )
}

export default WorkHistoryPage